import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'plyca-ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlycaUiAlertComponent {
  @Input() typeClass: string = 'alert-info';
  @Input() marginClass: string = 'm-b-xs';
}

